import { dateInNormal } from "@/helpers/datetimeHandlers";
import { useTranslation } from "@/langs/useTranslation";

function ScheduleTaskRange({ data }) {
  const { t } = useTranslation();

  data.json = data.json || JSON.parse(data.taskScheduleJson || "{}");
  const start_datetime =
    data.json.start_date || data.json.start_datetime || data.start_datetime;
  const end_datetime =
    data.json.end_date || data.json.end_datetime || data.end_datetime;
  const end_type = data.json.end_type || data.end_type;
  const isForever = end_type === "forever";

  return (
    <>
      {dateInNormal(start_datetime)} -{" "}
      {isForever ? (
        "forever"
      ) : (
        <>
          {end_type === "datetime" && end_datetime
            ? dateInNormal(end_datetime)
            : null}{" "}
          {data.json.run_times
            ? t({ defaultMessage: "执行{num}次" }, { num: data.json.run_times })
            : null}
        </>
      )}
    </>
  );
}

export default ScheduleTaskRange;
